import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CookieConsentModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (consent) return;

    if (window.location.pathname === "/privacy") {
      const timer = setTimeout(() => setOpen(true), 1000);
      return () => clearTimeout(timer);
    }

    setOpen(true);
  }, []);

  const handleConsent = (value) => {
    const timestamp = new Date().toISOString();
    const data = { consent: value, date: timestamp };

    Cookies.set("cookie_consent", JSON.stringify(data), { expires: 90 });

    setOpen(false);
  };

  const handleLearnMore = () => {
    setOpen(false);
    setTimeout(() => {
      window.location.href = "/privacy";
    }, 200);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div style={styles.barWrapper}>
      <div style={styles.cookieBar}>
        <span style={styles.closeBtn} onClick={handleClose}>✕</span>

        <p style={styles.text}>
          Simply Halls uses cookies to ensure the platform works smoothly and enhances your booking experience.
          By clicking Accept, you agree to our cookie policy.
          <span onClick={handleLearnMore} style={styles.learnMore}>
            {" "}Learn more
          </span>
        </p>

        <div style={styles.actions}>
          <button style={styles.rejectBtn} onClick={() => handleConsent("rejected")}>
            Reject
          </button>
          <button style={styles.acceptBtn} onClick={() => handleConsent("accepted")}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  barWrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    zIndex: 9999,
    animation: "slideUp 0.9s ease-out",
  },
  cookieBar: {
    width: "100%",
    background: "#fff",
    padding: "16px 20px",
    borderTop: "2px solid #eb2a25",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    boxShadow: "0 -3px 10px rgba(0,0,0,0.15)",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: "8px",
    right: "12px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "18px",
    color: "#555",
  },
  text: {
    fontSize: "14px",
    margin: 0,
  },
  learnMore: {
    color: "#eb2a25",
    cursor: "pointer",
    fontWeight: "600",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  acceptBtn: {
    padding: "8px 18px",
    background: "#eb2a25",
    border: "none",
    color: "#fff",
    borderRadius: "4px",
    cursor: "pointer",
  },
  rejectBtn: {
    padding: "8px 18px",
    background: "#777",
    border: "none",
    color: "#fff",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default CookieConsentModal;
